import useDocumentTitle from "./hooks/useDocumentTitle";

const withDocumentTitle = (WrappedComponent, title) => props => {
	useDocumentTitle(title);
	return <WrappedComponent title={title} {...props} />;
};

export default withDocumentTitle;